// extracted by mini-css-extract-plugin
export var addButton = "_5c-d";
export var bullets = "_5c-e";
export var compact = "_5c-2";
export var container = "_5c-j";
export var extendedWarrantyModal = "_5c-f";
export var learn = "_5c-l";
export var learnMore = "_5c-g";
export var offeringOption = "_5c-3";
export var offeringPrice = "_5c-8";
export var offeringSubtitle = "_5c-7";
export var offeringTitle = "_5c-6";
export var offeringsContainer = "_5c-0";
export var pdpTilesBackground = "_5c-n";
export var plan = "_5c-m";
export var regular = "_5c-1";
export var remove = "_5c-k";
export var seeDetailsIcon = "_5c-i";
export var seeDetailsLink = "_5c-h";
export var selectedOption = "_5c-4";
export var shieldIcon = "_5c-b";
export var shieldIconCompact = "_5c-c";
export var subtitle = "_5c-a";
export var title = "_5c-9";
export var unselectedOption = "_5c-5";